<template>
  <div>
    <div class="form-fields">
      <div class="row" v-if="form.projectType === 'demolition'">
        <div class="col-12 col-md-6">
          <base-file-uploader v-model="form.files.platOfSurvey"
                              :validation="val.form.files.platOfSurvey"
                              :file="form.existingFileDetails.platOfSurvey"
                              label="Plat of Survey/Arial View of Site:" />
        </div>
        <div class="col-12 col-md-6">
          <base-file-uploader v-model="form.files.taxSummary"
                              :file="form.existingFileDetails.taxSummary"
                              :validation="val.form.files.taxSummary"
                              label="Copy of Official Cook County Tax Bill:" />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <base-file-uploader v-model="form.files.supportingDocument"
                              :file="form.existingFileDetails.supportingDocument"
                              :label="form.projectType === 'demolition'
                                  ? 'Additonal Documentation:'
                                  : 'Supporting Documentation:'" />
        </div>
      </div>
      <p>
        <small>
          I certify that the statements in this application are true and accurate to the best of my knowledge and belief;
          and, that all work under the proposed permit will conform to the drawings, specifications, and other information
          attached to this application; and, will conform to the Cook County Environmental Code Ordinance. All fees are non-refundable.
        </small>
      </p>
      <base-input v-model="form.name"
                  label="Owner, Applicant, or Authorized Agent:"
                  placeholder="Full Name"
                  :validation="val.form.name" />
      <base-input v-model="form.title"
                  label="Submitter's Title"
                  :validation="val.form.title" />
      <base-date-picker v-model="form.signDate"
                        label="Date"
                        :validation="val.form.signDate" />
    </div>
  </div>
</template>

<script>
import ExplodedFieldset from '~/components/ExplodedFieldset';
import BaseInput from '~/components/BaseInput';
import BaseDatePicker from '~/components/BaseDatePicker';
import BaseFileUploader from '~/components/BaseFileUploader';

export default {
  name: 'Signature',
  components: {
    ExplodedFieldset, BaseInput, BaseDatePicker, BaseFileUploader,
  },
  props: ['form', 'val'],
  mounted() {
    this.$emit('update:title', 'Attachments & Signature');
  },
};
</script>
